export interface Video {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  rating: number;
  year: number;
  region: string;
  duration: string;
  description: string;
  tags: string[];
  director: string;
  cast: string[];
  updateDate: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  isVip: boolean;
}

export const allVideos: Video[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20deep%20blue%20color%20scheme%2C%20movie%20poster%20aesthetic%2C%20clean%20minimal%20design&width=600&height=800&seq=baiyun-video-01&orientation=portrait',
    rating: 9.1,
    year: 2025,
    region: '中国大陆',
    duration: '148分钟',
    description: '太阳急速老化，持续膨胀，一百年后将吞没地球。人类在地球表面建造出巨大的推进器，寻找新的家园。面对前所未有的危机，年轻一代挺身而出，展开争分夺秒的生死之战。影片以宏大的宇宙视角和细腻的情感刻画，展现人类在绝境中的勇气与希望。',
    tags: ['科幻', '灾难', '冒险', '国产大片'],
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    updateDate: '2025-07-28',
    views: 2856000,
    isHot: true,
    isNew: true,
    isVip: false,
  },
  {
    id: 2,
    title: '繁花',
    category: '电视剧',
    categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20style%2C%201990s%20Shanghai%20aesthetic%2C%20nostalgic%20warm%20golden%20lighting%2C%20elegant%20art%20deco%20elements%2C%20TV%20drama%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=baiyun-video-02&orientation=portrait',
    rating: 9.4,
    year: 2024,
    region: '中国大陆',
    duration: '30集',
    description: '九十年代的上海，处处是机遇与挑战。阿宝凭借改革开放的春风，从默默无闻的小人物成长为商界后起之秀。在黄河路上，他经历了商海沉浮、人生起伏，见证了上海这座城市的沧桑巨变与繁华荣光。',
    tags: ['年代剧', '商战', '爱情', '王家卫'],
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    updateDate: '2025-07-30',
    views: 4521000,
    isHot: true,
    isNew: false,
    isVip: true,
  },
  {
    id: 3,
    title: '乘风破浪的姐姐 第五季',
    category: '综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20style%2C%20women%20empowerment%20theme%2C%20stage%20performance%20atmosphere%2C%20vibrant%20colorful%20lighting%2C%20elegant%20design%2C%20clean%20composition&width=600&height=800&seq=baiyun-video-03&orientation=portrait',
    rating: 8.7,
    year: 2025,
    region: '中国大陆',
    duration: '12期',
    description: '30位30+姐姐重新出发，在舞台上突破自我、挑战极限。本季赛制全面升级，姐姐们将面临更激烈的竞争与更精彩的舞台呈现，用实力诠释"三十而骊"的真谛。',
    tags: ['真人秀', '音乐', '竞技', '女性'],
    director: '吴梦知',
    cast: ['宁静', '那英', '张雨绮', '万茜'],
    updateDate: '2025-08-01',
    views: 5230000,
    isHot: true,
    isNew: true,
    isVip: true,
  },
  {
    id: 4,
    title: '哪吒之魔童闹海',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20mythological%20character%20in%20dynamic%20action%20pose%2C%20traditional%20Chinese%20art%20style%20with%20modern%20animation%20aesthetic%2C%20vibrant%20red%20and%20gold%20accents%2C%20epic%20composition&width=600&height=800&seq=baiyun-video-04&orientation=portrait',
    rating: 9.3,
    year: 2025,
    region: '中国大陆',
    duration: '132分钟',
    description: '天劫之后，哪吒和敖丙的灵魂虽然保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，但在重塑过程中却遇到重重困难，哪吒和敖丙的命运将走向何方？',
    tags: ['动画', '神话', '冒险', '国漫'],
    director: '饺子',
    cast: ['吕艳婷', '瀚墨', '陈浩', '绿绮'],
    updateDate: '2025-07-25',
    views: 6780000,
    isHot: true,
    isNew: true,
    isVip: false,
  },
  {
    id: 5,
    title: '舌尖上的中国 第四季',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20style%2C%20traditional%20Chinese%20cuisine%20photography%2C%20warm%20kitchen%20atmosphere%2C%20steaming%20dishes%2C%20cultural%20aesthetic%2C%20clean%20minimal%20design%20with%20food%20textures&width=600&height=800&seq=baiyun-video-05&orientation=portrait',
    rating: 9.2,
    year: 2025,
    region: '中国大陆',
    duration: '8集',
    description: '延续前三季的精良制作，第四季深入探索中国各地最地道的风味美食，讲述美食背后的人文故事。从东北雪乡到海南渔村，从川西高原到江南水乡，用镜头记录中国人舌尖上的乡愁。',
    tags: ['美食', '文化', '人文', '旅行'],
    director: '陈晓卿',
    cast: ['李立宏'],
    updateDate: '2025-07-20',
    views: 1890000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 6,
    title: '熊出没·重启未来',
    category: '少儿',
    categorySlug: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20animated%20bear%20characters%20in%20futuristic%20setting%2C%20children%20movie%20poster%20style%2C%20colorful%20and%20playful%20design%2C%20forest%20and%20technology%20elements%2C%20warm%20and%20inviting%20aesthetic&width=600&height=800&seq=baiyun-video-06&orientation=portrait',
    rating: 8.5,
    year: 2025,
    region: '中国大陆',
    duration: '95分钟',
    description: '熊大、熊二和光头强意外穿越到未来世界，发现未来的森林面临着前所未有的危机。他们必须团结一致，运用智慧和勇气，拯救未来的家园，开启一段充满惊喜与挑战的时空冒险。',
    tags: ['动画', '冒险', '喜剧', '亲子'],
    director: '林汇达',
    cast: ['张伟', '张秉君', '谭笑'],
    updateDate: '2025-07-15',
    views: 3200000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 7,
    title: '封神第二部：战火西岐',
    category: '电影',
    categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20battle%2C%20dramatic%20cinematic%20lighting%2C%20traditional%20armor%20and%20weapons%2C%20epic%20scale%20composition%2C%20warm%20bronze%20and%20gold%20tones&width=600&height=800&seq=baiyun-video-07&orientation=portrait',
    rating: 8.9,
    year: 2025,
    region: '中国大陆',
    duration: '156分钟',
    description: '姬发回到西岐后，殷商大军兵临城下。在姜子牙和昆仑仙人的帮助下，西岐军民为保卫家园展开殊死搏斗。封神大战一触即发，三界命运将在这场旷世之战中被改写。',
    tags: ['神话', '战争', '奇幻', '史诗'],
    director: '乌尔善',
    cast: ['费翔', '黄渤', '于适', '李雪健'],
    updateDate: '2025-07-22',
    views: 4100000,
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: 8,
    title: '狂飙',
    category: '电视剧',
    categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20style%2C%20police%20and%20underworld%20theme%2C%20dark%20moody%20atmosphere%2C%20urban%20noir%20aesthetic%2C%20tense%20confrontation%20vibe%2C%20clean%20modern%20poster%20design&width=600&height=800&seq=baiyun-video-08&orientation=portrait',
    rating: 9.5,
    year: 2023,
    region: '中国大陆',
    duration: '39集',
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开长达二十年的生死较量。通过群像叙事展现扫黑除恶过程中的惊心动魄，折射出社会变迁中的人性抉择。',
    tags: ['刑侦', '扫黑', '悬疑', '现实题材'],
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    updateDate: '2025-06-20',
    views: 8900000,
    isHot: true,
    isNew: false,
    isVip: false,
  },
  {
    id: 9,
    title: '奔跑吧 第十二季',
    category: '综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20sunny%20outdoor%20setting%2C%20energetic%20colorful%20aesthetic%2C%20fun%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=baiyun-video-09&orientation=portrait',
    rating: 8.3,
    year: 2025,
    region: '中国大陆',
    duration: '12期',
    description: '兄弟团全新阵容再次出发，走遍祖国大江南北，挑战各种趣味游戏，传递奔跑的快乐。新一季加入了更多素人互动环节，让节目更加贴近生活，欢笑不断。',
    tags: ['户外', '真人秀', '游戏', '搞笑'],
    director: '姚译添',
    cast: ['李晨', '郑恺', '杨颖', '白鹿'],
    updateDate: '2025-08-01',
    views: 3560000,
    isHot: false,
    isNew: true,
    isVip: true,
  },
  {
    id: 10,
    title: '深海',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20underwater%20fantasy%20world%2C%20colorful%20coral%20reef%20and%20marine%20life%2C%20dreamlike%20visual%20style%2C%20girl%20character%20in%20flowing%20dress%2C%20ethereal%20lighting%2C%20artistic%20composition&width=600&height=800&seq=baiyun-video-10&orientation=portrait',
    rating: 8.8,
    year: 2024,
    region: '中国大陆',
    duration: '112分钟',
    description: '一个患有抑郁症的女孩参宿，在海上遭遇意外后，神奇地来到一个五彩斑斓的海底世界。在这里，她遇到了一个神秘少年南河，开启了一场治愈心灵的奇幻深海冒险。',
    tags: ['奇幻', '治愈', '冒险', '国漫'],
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文'],
    updateDate: '2025-06-15',
    views: 1450000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 11,
    title: '哆啦A梦：大雄的地球交响乐',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20style%20Doraemon%20and%20friends%20with%20music%20theme%2C%20colorful%20orchestra%20instruments%2C%20whimsical%20fantasy%20setting%2C%20bright%20cheerful%20colors%2C%20clean%20composition&width=600&height=800&seq=baiyun-video-11&orientation=portrait',
    rating: 8.6,
    year: 2025,
    region: '日本',
    duration: '115分钟',
    description: '大雄和哆啦A梦用秘密道具「音乐家许可证」召集伙伴们一起组建乐队，却意外卷入了拯救音乐之星「珐籁」的冒险。音乐的力量能否拯救世界？一场充满欢笑与感动的音乐大冒险即将上演。',
    tags: ['动画', '冒险', '音乐', '经典IP'],
    director: '今井一晓',
    cast: ['水田山葵', '大原惠美', '嘉数由美'],
    updateDate: '2025-07-10',
    views: 2100000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 12,
    title: '庆余年 第二季',
    category: '电视剧',
    categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20fantasy%20drama%20poster%2C%20ancient%20Chinese%20court%20setting%2C%20handsome%20male%20lead%20in%20traditional%20robe%2C%20political%20intrigue%20atmosphere%2C%20golden%20and%20crimson%20color%20scheme%2C%20elegant%20composition&width=600&height=800&seq=baiyun-video-12&orientation=portrait',
    rating: 9.3,
    year: 2024,
    region: '中国大陆',
    duration: '36集',
    description: '范闲假死归来，重返京都。面对更加复杂的朝堂局势，他在各方势力间周旋，一步步揭开身世之谜。庆帝的阴谋、陈萍萍的秘密、叶轻眉的往事……一切真相即将浮出水面。',
    tags: ['古装', '权谋', '玄幻', '小说改编'],
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    updateDate: '2025-07-18',
    views: 7560000,
    isHot: true,
    isNew: false,
    isVip: true,
  },
  {
    id: 13,
    title: '复仇者联盟5：康之王朝',
    category: '电影',
    categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Superhero%20movie%20poster%20style%2C%20group%20of%20heroes%20in%20dynamic%20action%20poses%2C%20epic%20cosmic%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20bold%20heroic%20aesthetic&width=600&height=800&seq=baiyun-video-13&orientation=portrait',
    rating: 8.4,
    year: 2025,
    region: '美国',
    duration: '162分钟',
    description: '征服者康的全面入侵让整个多元宇宙陷入危机。剩余的复仇者们必须联合来自不同时间线的英雄，组成史上最强大的联盟，在时空尽头展开一场决定多元宇宙命运的终极决战。',
    tags: ['动作', '科幻', '超级英雄', '好莱坞'],
    director: '德斯汀·克里顿',
    cast: ['小罗伯特·唐尼', '克里斯·埃文斯', '斯嘉丽·约翰逊'],
    updateDate: '2025-07-05',
    views: 5200000,
    isHot: true,
    isNew: true,
    isVip: false,
  },
  {
    id: 14,
    title: '珠峰队长',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Documentary%20poster%20about%20mountain%20climbing%2C%20Everest%20mountain%20in%20background%2C%20climbers%20silhouette%2C%20snow%20and%20ice%20landscape%2C%20adventure%20atmosphere%2C%20cinematic%20photography%20style%2C%20clean%20minimal%20design&width=600&height=800&seq=baiyun-video-14&orientation=portrait',
    rating: 8.9,
    year: 2024,
    region: '中国大陆',
    duration: '83分钟',
    description: '一支由普通登山爱好者组成的队伍，在中国藏族向导的带领下，挑战世界之巅珠穆朗玛峰。影片全程实景拍摄，记录了他们从准备到登顶的每一步，展现了人类的勇气与极限挑战精神。',
    tags: ['冒险', '极限运动', '自然', '人文'],
    director: '吴京',
    cast: ['苏拉王平'],
    updateDate: '2025-06-10',
    views: 890000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 15,
    title: '长安三万里',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20Tang%20Dynasty%20aesthetic%2C%20ancient%20Chinese%20city%20Changan%2C%20poets%20and%20warriors%2C%20traditional%20ink%20painting%20style%20with%203D%20animation%2C%20golden%20and%20jade%20color%20scheme%2C%20epic%20composition&width=600&height=800&seq=baiyun-video-15&orientation=portrait',
    rating: 9.0,
    year: 2023,
    region: '中国大陆',
    duration: '168分钟',
    description: '安史之乱后数年，吐蕃大军入侵西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事，两个天才诗人截然不同的命运轨迹，交织成一幅大唐由盛转衰的历史画卷。',
    tags: ['历史', '诗歌', '传记', '国漫'],
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    updateDate: '2025-05-20',
    views: 3400000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 16,
    title: '萌娃大冒险',
    category: '少儿',
    categorySlug: 'kids',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20children%20animation%20poster%2C%20colorful%20fantasy%20forest%20with%20friendly%20animals%2C%20group%20of%20diverse%20kids%20characters%2C%20educational%20theme%2C%20bright%20playful%20colors%2C%20clean%20wholesome%20design&width=600&height=800&seq=baiyun-video-16&orientation=portrait',
    rating: 8.2,
    year: 2025,
    region: '中国大陆',
    duration: '52集',
    description: '五个性格各异的小朋友在神奇森林中展开探险，每一集都通过有趣的冒险故事教会孩子们生活中的道理。寓教于乐，让孩子在欢笑中学习成长。',
    tags: ['教育', '冒险', '友情', '学龄前'],
    director: '李明',
    cast: ['王小丫', '张朵朵'],
    updateDate: '2025-07-08',
    views: 980000,
    isHot: false,
    isNew: true,
    isVip: false,
  },
  {
    id: 17,
    title: '孤注一掷',
    category: '电影',
    categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20dark%20and%20tense%20atmosphere%2C%20urban%20night%20scene%2C%20mysterious%20characters%20silhouette%2C%20gambling%20theme%20elements%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20clean%20modern%20design&width=600&height=800&seq=baiyun-video-17&orientation=portrait',
    rating: 8.8,
    year: 2024,
    region: '中国大陆',
    duration: '138分钟',
    description: '取材自上万起真实诈骗案例，揭露境外网络诈骗全产业链的骇人内幕。程序员潘生和模特安娜被高薪招聘所吸引，来到海外淘金，却意外陷入了境外诈骗工厂的陷阱中。',
    tags: ['犯罪', '剧情', '社会现实', '反诈'],
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君'],
    updateDate: '2025-06-25',
    views: 3400000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 18,
    title: '向往的生活 第九季',
    category: '综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20slow-life%20variety%20show%20poster%2C%20countryside%20farmhouse%20setting%2C%20celebrities%20cooking%20and%20farming%2C%20warm%20sunset%20lighting%2C%20pastoral%20aesthetic%2C%20cozy%20atmosphere%2C%20clean%20natural%20design&width=600&height=800&seq=baiyun-video-18&orientation=portrait',
    rating: 8.6,
    year: 2025,
    region: '中国大陆',
    duration: '14期',
    description: '黄磊与何炅带领新老朋友回归蘑菇屋，在远离都市喧嚣的田园中，自给自足、招待好友。每一期都有惊喜嘉宾到访，分享美食与故事，传递"向往的生活"真谛。',
    tags: ['慢综艺', '美食', '田园', '治愈'],
    director: '王征宇',
    cast: ['黄磊', '何炅', '张艺兴', '彭昱畅'],
    updateDate: '2025-07-28',
    views: 2780000,
    isHot: false,
    isNew: true,
    isVip: true,
  },
  {
    id: 19,
    title: '独行月球',
    category: '电影',
    categorySlug: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20comedy%20movie%20poster%2C%20astronaut%20on%20moon%20surface%2C%20lonely%20and%20humorous%20vibe%2C%20Earth%20in%20distant%20background%2C%20space%20theme%2C%20warm%20and%20cool%20color%20contrast%2C%20cinematic%20composition&width=600&height=800&seq=baiyun-video-19&orientation=portrait',
    rating: 8.5,
    year: 2023,
    region: '中国大陆',
    duration: '122分钟',
    description: '人类为抵御小行星撞击，在月球部署了月盾计划。陨石提前来袭，全员紧急撤离，维修工独孤月因为意外错过了撤离通知，一个人被留在了月球上。他以为自己是最后的人类，开始了破罐子破摔的月球生活。',
    tags: ['科幻', '喜剧', '励志', '沈腾'],
    director: '张吃鱼',
    cast: ['沈腾', '马丽', '黄才伦', '常远'],
    updateDate: '2025-05-15',
    views: 4200000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
  {
    id: 20,
    title: '隐秘的角落',
    category: '电视剧',
    categorySlug: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20drama%20poster%2C%20three%20children%20in%20mysterious%20atmosphere%2C%20coastal%20town%20setting%2C%20dark%20secrets%20theme%2C%20moody%20lighting%2C%20psychological%20thriller%20vibe%2C%20clean%20modern%20design&width=600&height=800&seq=baiyun-video-20&orientation=portrait',
    rating: 9.4,
    year: 2020,
    region: '中国大陆',
    duration: '12集',
    description: '沿海小城的三个孩子在景区游玩时，无意间拍摄记录了一次谋杀。由此，他们的命运跟一个杀人犯紧紧联系在了一起。扑朔迷离的案情，将几个家庭裹挟其中，带向不可预知的未来。',
    tags: ['悬疑', '犯罪', '家庭', '社会派'],
    director: '辛爽',
    cast: ['秦昊', '王景春', '荣梓杉', '史彭元'],
    updateDate: '2025-06-05',
    views: 6100000,
    isHot: false,
    isNew: false,
    isVip: false,
  },
];